<template>
    <div class="fill-height bg-vector-img">
        <!-- Header BLock Start -->
        <div class="header-block py-0">
            <div class="row justify-center">
                <div class="col-12 text-center py-0">
                    <div
                        class="mx-auto"
                        v-show="isLogoAnimationCompleted"
                        style="
                            width: 344px;
                            height: 190px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        "
                        >
                            <img
                                style="max-width: 268px"
                                src="@/assets/images/logo/noodzly-logo.png"
                            />
                        </div>
                        <img
                            v-show="!isLogoAnimationCompleted"
                            style="width: 344px"
                            src="@/assets/logo_animation.gif"
                        />
                </div>
            </div>
        </div>
        <!-- Header BLock Start -->

        <!-- Hero Section Start -->
        <div class="hero-block block pt-0">
            <v-container>
                <div class="row">
                    <div class="col-12 col-lg-7 hero-content mb-0">
                        <div class="hero-content-inner">
                            <h1 class="text-white text-center text-md-left mb-5 mb-md-2">{{ $t('pages.home.hero_content.title') }}</h1>
                            <p class="pb-0 text-center text-md-left mb-5 mb-md-0">{{ $t('pages.home.hero_content.description') }}</p>
                            <div class="button-wrapper d-flex d-md-none ga-4 items-center mt-md-7 mb-md-12">
                                <a @click="actionSignup" class="btn btn-primary">{{ $t('pages.home.hero_content.cta_1') }}</a>
                                <a @click="actionLogin" class="btn btn-secondary ms-3">{{ $t('pages.home.hero_content.cta_2') }}</a>
                            </div>
                            <div class="button-wrapper d-none d-md-flex ga-4 items-center mt-md-7 mb-md-12">
                                <a @click.prevent="scrollToCtaBlock" class="btn btn-primary">{{ $t('pages.home.hero_content.cta_1') }}</a>
                                <a @click.prevent="scrollToCtaBlock" class="btn btn-secondary ms-3">{{ $t('pages.home.hero_content.cta_2') }}</a>
                            </div>

                            <!-- <div class="row counter-items mt-10">
                                <div class="col-4 col-sm-3 counter-item">
                                    <div class="counter-item-inner text-center text-md-left">
                                        <span>5000+</span>
                                        <p class="mb-0">{{ $t('pages.home.hero_content.stats_1') }}</p>
                                    </div>
                                </div>
                                <div class="col-4 col-sm-3 counter-item">
                                    <div class="counter-item-inner text-center text-md-left">
                                        <span>$2M+</span>
                                        <p class="mb-0">{{ $t('pages.home.hero_content.stats_2') }}</p>
                                    </div>
                                </div>
                                <div class="col-4 col-sm-3 counter-item">
                                    <div class="counter-item-inner text-center text-md-left">
                                        <span>1M+</span>
                                        <p class="mb-0">{{ $t('pages.home.hero_content.stats_3') }}</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 offset-lg-1 d-none d-md-block hero-block-img">
                        <div class="text-center">
                            <h6 class="px-lg-5 mb-5">
                                {{ $t('pages.home.hero_block_img.text_1') }}<br>
                                {{ $t('pages.home.hero_block_img.text_2') }}
                            </h6>
                            <div class="img-wrapper">
                                <img
                                    loading="lazy"
                                    alt="scan QR code"
                                    :src="require('@/assets/images/splash/scan-QR-code.png')"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </v-container>
        </div>
        <!-- Hero Section End -->

        <!-- What’s Noodzly? Start -->
        <div class="about-us-block block pt-0 pt-lg-10">
            <v-container>
                <div class="row justify-center mb-lg-10">
                    <div class="col-12 col-lg-11 text-center heading-style px-md-10">
                        <h2 class="mb-5">{{ $t('pages.home.about_us.title') }} <span>{{ $t('pages.home.about_us.title_highlight') }}</span></h2>
                        <p>{{ $t('pages.home.about_us.description') }}</p>
                    </div>
                </div>
                <div class="row icon-box-items">
                    <div class="col-6 col-lg-3 icon-box-item">
                        <div class="icon-box-inner text-center">
                            <img
                                loading="lazy"
                                class="mb-4"
                                :src="require('@/assets/images/splash/photo-video-icon.png')"
                                :alt="$t('pages.home.about_us.features.photo_video.alt')"
                            >
                            <h4>{{ $t('pages.home.about_us.features.photo_video.title') }}</h4>
                            <p class="mb-0">{{ $t('pages.home.about_us.features.photo_video.subtitle') }}</p>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3 icon-box-item">
                        <div class="icon-box-inner text-center">
                            <img
                                loading="lazy"
                                class="mb-4"
                                :src="require('@/assets/images/splash/live-streams-icon.png')"
                                :alt="$t('pages.home.about_us.features.live_streams.alt')"
                            >
                            <h4>{{ $t('pages.home.about_us.features.live_streams.title') }}</h4>
                            <p class="mb-0">{{ $t('pages.home.about_us.features.live_streams.subtitle') }}</p>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3 icon-box-item">
                        <div class="icon-box-inner text-center">
                            <img
                                loading="lazy"
                                class="mb-4"
                                :src="require('@/assets/images/splash/multiple-income-streams-icon.png')"
                                :alt="$t('pages.home.about_us.features.income_streams.alt')"
                            >
                            <h4>{{ $t('pages.home.about_us.features.income_streams.title') }}</h4>
                            <p class="mb-0">{{ $t('pages.home.about_us.features.income_streams.subtitle') }}</p>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3 icon-box-item">
                        <div class="icon-box-inner text-center">
                            <img
                                loading="lazy"
                                class="mb-4"
                                :src="require('@/assets/images/splash/24h-auto-delete-icon.png')"
                                :alt="$t('pages.home.about_us.features.auto_delete.alt')"
                            >
                            <h4>{{ $t('pages.home.about_us.features.auto_delete.title') }}</h4>
                            <p class="mb-0">{{ $t('pages.home.about_us.features.auto_delete.subtitle') }}</p>
                        </div>
                    </div>
                </div>

                <div class="row mt-md-7">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-inline-block d-md-none">
                            <a @click="actionSignup" class="btn btn-primary">{{ $t('pages.home.about_us.cta') }}</a>
                        </div>
                    </div>
                </div>
                <div class="row mt-md-7">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-none d-md-inline-block">
                            <a @click.prevent="scrollToCtaBlock" class="btn btn-primary">{{ $t('pages.home.about_us.cta') }}</a>
                        </div>
                    </div>
                </div>
            </v-container>
        </div>
        <!-- What’s Noodzly? End -->

        <!-- Benefits for Creators Start -->
        <div class="benefits-block block pt-0 pt-lg-10">
            <v-container>
                <div class="row justify-center">
                    <div class="col-12 col-lg-11 text-center heading-style px-lg-10">
                        <h2 class="mb-5">{{ $t('pages.home.creator_benefits.title_part1') }} <span>{{ $t('pages.home.creator_benefits.title_part2') }}</span></h2>
                        <p>{{ $t('pages.home.creator_benefits.subtitle') }}</p>
                    </div>
                </div>

                <div class="row justify-center icon-left-box-items px-lg-10">
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/subscriptions-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.subscriptions.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.subscriptions.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/photo-video-dark-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.photo_video.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.photo_video.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/pay-per-view-content-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.pay_per_view.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.pay_per_view.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/private-streams-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.private_streams.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.private_streams.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/tips-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.tips.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.tips.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/private-requests-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.private_requests.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.private_requests.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/mystery_reward.png')"
                                    :alt="$t('pages.home.creator_benefits.mystery_box.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.mystery_box.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/referral-program-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.referral_program.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.referral_program.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/and-much-more-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.and_more.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.creator_benefits.and_more.title') }}</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <h3 class="mt-8 mb-sm-3 text-center">{{ $t('pages.home.creator_benefits.better_title') }}</h3>

                <div class="row justify-center icon-top-box-items">
                    <div class="col-12 col-sm-6 col-lg-4 icon-top-box-item">
                        <div class="icon-top-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/subscriptions-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.better_features.live_solo.alt')"
                                >
                            </div>
                            <h4>{{ $t('pages.home.creator_benefits.better_features.live_solo.text') }}</h4>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-top-box-item">
                        <div class="icon-top-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/photo-video-dark-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.better_features.holiday_mode.alt')"
                                >
                            </div>
                            <h4>{{ $t('pages.home.creator_benefits.better_features.holiday_mode.text') }}</h4>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-top-box-item">
                        <div class="icon-top-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/pay-per-view-content-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.better_features.privacy_controls.alt')"
                                >
                            </div>
                            <h4>{{ $t('pages.home.creator_benefits.better_features.privacy_controls.text') }}</h4>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-top-box-item">
                        <div class="icon-top-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/private-streams-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.better_features.disappearing_content.alt')"
                                >
                            </div>
                            <h4>{{ $t('pages.home.creator_benefits.better_features.disappearing_content.text') }}</h4>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-top-box-item">
                        <div class="icon-top-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/tips-icon.png')"
                                    :alt="$t('pages.home.creator_benefits.better_features.fast_payouts.alt')"
                                >
                            </div>
                            <h4>{{ $t('pages.home.creator_benefits.better_features.fast_payouts.text') }}</h4>
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-inline-block d-md-none">
                            <a @click="actionSignup" class="btn btn-primary">{{ $t('pages.home.creator_benefits.cta_button') }}</a>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-none d-md-inline-block">
                            <a @click.prevent="scrollToCtaBlock" class="btn btn-primary">{{ $t('pages.home.creator_benefits.cta_button') }}</a>
                        </div>
                    </div>
                </div>
            </v-container>
        </div>
        <!-- Benefits for Creators End -->

        <!-- Benefits for Fans Start -->
        <div class="benefits-block block pt-0 pt-lg-10">
            <v-container>
                <div class="row justify-center">
                    <div class="col-12 col-lg-11 text-center heading-style px-lg-10">
                        <h2 class="mb-5">{{ $t('pages.home.fan_benefits.title_part1') }} <span>{{ $t('pages.home.fan_benefits.title_part2') }}</span></h2>
                        <p>{{ $t('pages.home.fan_benefits.subtitle') }}</p>
                    </div>
                </div>

                <div class="row justify-center icon-left-box-items px-lg-10">
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/discover-real-unfiltered-content-icon.png')"
                                    :alt="$t('pages.home.fan_benefits.discover_content.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.fan_benefits.discover_content.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/real-time-people-and-moments-icon.png')"
                                    :alt="$t('pages.home.fan_benefits.real_time.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.fan_benefits.real_time.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/subscribe-to-your-favorite-creators-icon.png')"
                                    :alt="$t('pages.home.fan_benefits.subscribe.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.fan_benefits.subscribe.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/send-tips-or-request-something-personal-icon.png')"
                                    :alt="$t('pages.home.fan_benefits.tips_requests.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.fan_benefits.tips_requests.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/sign-up-with-just-an-email-and-password-icon.png')"
                                    :alt="$t('pages.home.fan_benefits.easy_signup.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.fan_benefits.easy_signup.title') }}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 icon-left-box-item">
                        <div class="icon-left-box-inner">
                            <div class="icon-box">
                                <img
                                    loading="lazy"
                                    class="mb-0"
                                    :src="require('@/assets/images/splash/in-app-wallet-to-support-your-faves-icon.png')"
                                    :alt="$t('pages.home.fan_benefits.wallet.alt')"
                                >
                            </div>
                            <div class="icon-box-content">
                                <h4>{{ $t('pages.home.fan_benefits.wallet.title') }}</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-inline-block d-md-none">
                            <a @click="actionSignup" class="btn btn-primary">{{ $t('pages.home.fan_benefits.cta_button') }}</a>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-none d-md-inline-block">
                            <a @click.prevent="scrollToCtaBlock" class="btn btn-primary">{{ $t('pages.home.fan_benefits.cta_button') }}</a>
                        </div>
                    </div>
                </div>
            </v-container>
        </div>
        <!-- Benefits for Fans End -->

        <!-- Why creators and fans choose Noodzly Start  -->

        <div class="choose-noodzly-block block pt-0 pt-lg-10">
            <v-container>
                <div class="row">
                    <div class="col-12 col-lg-11 text-center heading-style px-lg-10">
                        <h2 class="mb-5">{{ $t('pages.home.choose_noodzly.title_part1') }} <span>{{ $t('pages.home.choose_noodzly.title_part2') }}</span></h2>
                    </div>
                </div>
                <div class="simplified-table-container">
                    <div class="row feature-items">
                        <div class="col-3 feature-item sticky">
                            <div class="highlighted-header others-header">
                            </div>
                            <div class="feature-inner" v-for="(row, index) in featureTitle" :key="index">
                                <span>{{ row.title }} {{ row.icon }}</span>
                            </div>
                        </div>
                        <div class="col-6 col-lg-4 feature-item">
                            <div class="highlighted-header others-header">
                                <h3>Others</h3>
                            </div>
                            <div class="feature-inner" v-for="(row, index) in featureOthers" :key="index">
                                <p>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M17 2.81738L14.1826 0L8.50002 5.6826L2.81738 0L0 2.81738L5.68264 8.49998L0 14.1826L2.81738 17L8.50002 11.3174L14.1826 17L17 14.1826L11.3174 8.49998L17 2.81738Z" fill="#FF3131"/>
                                        </svg>
                                    </span>
                                    {{ row.old }}
                                </p>
                            </div>
                        </div>
                        <div class="col-6 col-lg-4 feature-item highlighted">
                            <div class="highlighted-header noodzly-header">
                                <img style="max-width: 268px" src="@/assets/images/logo/noodzly-logo.png" />
                            </div>
                            <div class="feature-inner highlighted" v-for="(row, index) in featureNoodzly" :key="index">
                                <p>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
                                            <path d="M20.8207 0L8.59241 11.3443L3.42096 5.8255L0 9.03113L8.35474 17.9471L24 3.44623L20.8207 0Z" fill="#2ADF3F"/>
                                        </svg>
                                    </span>
                                    {{ row.new }}
                                </p>
                            </div>
                        </div>
                    </div>  
                </div>
               
                <div class="row mt-7 mt-lg-10">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-inline-block d-md-none">
                            <a @click="actionSignup" class="btn btn-primary">{{ $t('pages.home.choose_noodzly.cta_button') }}</a>
                        </div>
                    </div>
                </div>
                <div class="row mt-7 mt-lg-10">
                    <div class="col-12 text-center">
                        <div class="btn-wrapper d-none d-md-inline-block">
                            <a @click.prevent="scrollToCtaBlock" class="btn btn-primary">{{ $t('pages.home.choose_noodzly.cta_button') }}</a>
                        </div>
                    </div>
                </div>
            </v-container>
        </div>        
        <!-- Why creators and fans choose Noodzly End  -->

        <!-- Safety first — Always Start -->
        <div class="safety-first-block block pt-0 pt-lg-10">
            <v-container>
                <div class="row justify-center px-lg-10 mb-sm-8 mb-lg-16">
                    <div class="col-12 col-lg-7 text-center heading-style">
                        <h2 class="mb-5">{{ $t('pages.home.safety.title') }} <span>{{ $t('pages.home.safety.title_highlight') }}</span></h2>
                        <p class="px-lg-16">{{ $t('pages.home.safety.subtitle') }}</p>
                    </div>
                </div>

                <div class="row flex-column-reverse flex-sm-row align-center px-lg-10 mb-8 mb-md-16">
                    <div class="col-12 col-sm-6">
                        <h3 class="mb-3">{{ $t('pages.home.safety.trusted_space.heading') }}</h3>
                        <ul>
                            <li>{{ $t('pages.home.safety.trusted_space.creators_verified') }}</li>
                            <li>{{ $t('pages.home.safety.trusted_space.profile_control') }}</li>
                            <li>{{ $t('pages.home.safety.trusted_space.auto_delete') }}</li>
                            <li>{{ $t('pages.home.safety.trusted_space.secure_payments') }}</li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 offset-lg-2 text-center text-md-end">
                        <img :src="require('@/assets/images/splash/built-noodzly-to-b-a-safe-trusted-space.png')" :alt="$t('pages.home.safety.trusted_space.image_alt')">
                    </div>
                </div>

                <div class="row align-center px-lg-10 mb-8 mb-md-16">
                    <div class="col-12 col-sm-6 col-lg-4 text-center text-md-start">
                        <img :src="require('@/assets/images/splash/protection-that-matters.png')" :alt="$t('pages.home.safety.protection.image_alt')">
                    </div>
                    <div class="col-12 col-sm-6 offset-lg-2">
                        <h3 class="mb-3 text-center text-sm-start">{{ $t('pages.home.safety.protection.heading') }}</h3>
                        <p class="mb-0 text-center text-sm-start">{{ $t('pages.home.safety.protection.description') }}</p>
                    </div>
                </div>

                <div class="row flex-column-reverse flex-sm-row align-center px-lg-10">
                    <div class="col-12 col-sm-6 pe-lg-10">
                        <h3 class="mb-3 text-center text-sm-start">{{ $t('pages.home.safety.support.heading_one') }} <br> {{ $t('pages.home.safety.support.heading_two') }}</h3>
                        <p class="mb-0 text-center text-sm-start">{{ $t('pages.home.safety.support.description') }}</p>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 offset-lg-2 text-center text-md-end">
                        <img :src="require('@/assets/images/splash/need-help-icon.png')" :alt="$t('pages.home.safety.support.image_alt')">
                    </div>
                </div>
            </v-container>
        </div>
        <!-- Safety first — Always End -->

        <!-- Call To Action Start -->
        <div class="cta-block block d-none d-md-block" ref="ctaBlock">
            <v-container>
                <div class="cta-block-inner">
                    <div class="row align-center">
                        <div class="col-12 col-lg-7">
                            <h2 class="mb-4">{{ $t('pages.home.cta.title') }}</h2>
                            <h6 class="mb-4">{{ $t('pages.home.cta.subtitle') }}</h6>
                            <p class="mb-0">{{ $t('pages.home.cta.description') }}</p>
                        </div>
                        <div class="col-12 col-lg-4 offset-lg-1">
                            <img
                                loading="lazy"
                                :alt="$t('pages.home.cta.qr_alt')"
                                :src="require('@/assets/images/splash/scan-QR-code.png')"
                            >
                        </div>
                    </div>
                </div>
            </v-container>
        </div>
        <!-- Call To Actions End -->

        <div class="footer-block">
            <v-container>
                <div class="mt-auto animate__animated animate__fadeInUp animate__fast">
                    <div class="pt-lg-10">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="text-center text-md-left">
                                    <img
                                        loading="lazy"
                                        class="mb-2"
                                        style="max-width: 155px"
                                        src="@/assets/images/logo/noodzly-logo.png"
                                    />
                                    <p class="mb-6">{{ $t('pages.home.footer_block.title') }}</p>
                                    <social-links class="justify-center justify-sm-start" />
                                </div>
                            </v-col>
    
                            <v-col cols="12" sm="6">
                                <div>
                                    <static-page-links template="simple" @openContactSupportPopup="showPopup = true" />
                                </div>
                            </v-col>
                        </v-row>
    
                        <v-row>
                            <v-col cols="12" class="position-relative copyright-footer" style="justify-items: center;">
                                <footer-logo class="mb-2 mt-0" />
                                <p class="mb-0" v-html="$t('pages.copyright', { year: new Date().getFullYear() })"></p>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-container>
        </div>

        <ContactUsDialog v-if="showPopup" @close="closePopup" />
        <common-dialog
            :dialog="showLoginForm"
            header-text="Delete Item?"
            @btnOne="actionLogin"
            @btnTwo="actionSignup"
            @close="showLoginForm = false"
        >
            <template v-slot:headline>
                Please Login or Signup...
            </template>
            <template v-slot:btn-one>
                Login
            </template>
            <template v-slot:btn-two>
                Signup
            </template>
        </common-dialog>
    </div>
</template>

<script>
import breaks from "@/mixins/breaks";
import SocialLinks from "@/components/app/auth/SocialLinks";
import { MESSAGE_ON_WELCOME_PAGE } from "@/configs/constants";
import StaticPageLinks from "@/components/app/common/StaticPageLinks";
import FooterContact from "@/components/app/common/FooterContact";
import FooterLogo from "@/components/app/common/FooterLogo";
import ContactUsDialog from "@/components/app/dialogs/ContactUsDialog";
import QrCode from "@/assets/images/splash/scan-QR-code.svg?inline";
import GreenCheckmark from "@/assets/images/icons/green-checkmark.svg?inline";
import CommonDialog from "@/components/app/dialogs/CommonDialog.vue";
import Settings from "../../models/Settings";

export default {
    name: "SplashScreen",
    metaInfo() {
        return {
            meta: [
                {
                    name: 'title',
                    content: 'Best Adult Social Network & Secure Content Sharing for Creators',
                    vmid: 'title'
                },
                {
                    name: 'description',
                    content: 'Join the best adult social network for content creators. Share exclusive and secure amateur content. Monetize your work and connect on a privacy-focused platform.',
                    vmid: 'description'
                }
            ],
        };
    },
    mixins: [breaks],
    data: () => ({
        welcomeMessage: MESSAGE_ON_WELCOME_PAGE,
        isLogoAnimationCompleted: false,
        showPopup: false,
        originalMetaDescription: null,
        scriptTag: null,
        showLoginForm: false,
        netFee: 15,
        featureTitle: [
            {
                title: "Earnings Fee",
                icon: "💰",
            },
            {
                title: "Content Lifespan",
                icon: "⏳",
            },
            {
                title: "Content Upload",
                icon: "📸",
            },
            {
                title: "Subscription System",
                icon: "💸",
            }, 
            {
                title: "Chargebacks",
                icon: "💳",
            },
            {
                title: "Gamification",
                icon: "🎯",                
            },
            {
                title: "Moderation",
                icon: "👮‍♀️",                
            },
            {
                title: "Pause Mode",
                icon: "🌴",                
            },
            {
                title: "Exposure",
                icon: "🚀",                
            },
            {
                title: "Creation Setup",
                icon: "🎥",                
            }
            
        ],
        featureOthers: [
            {
                old: "Up to 20-30%",
            },
            {
                old: "Content stays online forever - risk of leaks or misuse",                
            },
            {
                old: "Allows old, pre-edited, or fake uploads",                
            },
            {
                old: "Recurring credit card charges - often confusing",                
            },
            {
                old: "Frequent disputes from auto-renewals and card issues",                
            },
            {
                old: "Usually none",                
            },
            {
                old: "No reward for moderation",                
            },
            {
                old: "None",                
            },
            {
                old: "Competitive and hard to grow",                
            },
            {
                old: "Scripts, Lights and Pro-Cameras.",                
            }

        ],
    }),
    async mounted() {
        if (this.$route.query.showPopup === 'true') {
            this.showPopup = true;
        }

        if (process.env.NODE_ENV === 'production') {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "wiadg1jyhy");
        }

        this.fetchSetting();
        await this.navigateToHomePage();

        setTimeout(() => {
            this.isLogoAnimationCompleted = true;
        }, 3000);

        const existingMeta = document.querySelector('meta[name="description"]');
        if (existingMeta) {
            this.originalMetaDescription = existingMeta.getAttribute('content');
            existingMeta.remove();
        }       

        this.scriptTag = document.createElement("script");
        this.scriptTag.type = "application/ld+json";
        this.scriptTag.textContent = JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "noodzly",
            "url": "https://noodzly.com/",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "{search_term_string}",
                "query-input": "required name=search_term_string"
            }
        });

        document.head.appendChild(this.scriptTag);
    },
    computed: {
        screenWidth() {
            if (this.xlOnly) {
                return 289;
            }
            if (this.lgAndUp) {
                return 230;
            }

            return 150;
        },
        featureNoodzly() {
            return [
                { new: `Only ${this.netFee}% (even lower in some cases)` },
                { new: "Automatically deleted after 24 hours" },
                { new: "Only real-time content - no gallery uploads, 100% authentic" },
                { new: "Wallet system - full control, no hidden fees or auto-renewals" },
                { new: "Minimal risk thanks to prepaid wallet and transparent payments" },
                { new: "Badges, leaderboards, cash challenges, and contests" },
                { new: "Earn money by helping keep Noodzly safe" },
                { new: "Holiday Mode - pause subscriptions when you’re away" },
                { new: "Smart algorithm helps you get noticed and grow faster" },
                { new: "Just you, your phone, and the moment." },
            ];
        },
    },
    beforeDestroy() {
        this.hideTawkWidget();
        if (this.scriptTag && document.head.contains(this.scriptTag)) {
            document.head.removeChild(this.scriptTag);
        }
        if (this.originalMetaDescription) {
            const metaTag = document.createElement('meta');
            metaTag.name = 'description';
            metaTag.content = this.originalMetaDescription;
            document.head.appendChild(metaTag);
        }
    },
    methods: {
        navigateToHomePage: _.debounce(async function () {
            if (this.$auth.user() && this.showPopup == false) {
                await this.hideTawkWidget();
                this.$router
                    .push({ name: "auth.home" })
                    .catch((e) => console.log(e));
            } else {
                this.loadTawkWidget();
            }
        }, 200),
        closePopup(){
            this.showPopup = false;
            this.navigateToHomePage();
        },
        scrollToCtaBlock() {
            this.$nextTick(() => {
                const el = this.$refs.ctaBlock;
                if (el) {
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                }
            });
        },
        loadTawkWidget(){
            const scriptSrc = `https://embed.tawk.to/${process.env.VUE_APP_TAWK_PROPERTY_ID}/${process.env.VUE_APP_TAWK_WIDGET_ID}`;
            if (!window.Tawk_API) {
                // Dynamically load the Tawk.to script if not already loaded
                const tawkScript = document.createElement("script");
                tawkScript.id = "tawk-script";
                tawkScript.src = scriptSrc;
                tawkScript.async = true;
                tawkScript.charset = "UTF-8";
                tawkScript.setAttribute("crossorigin", "*");
                document.head.appendChild(tawkScript);

                window.Tawk_API = window.Tawk_API || {};
                window.Tawk_LoadStart = new Date();

                // Wait for the script to load, then show the widget
                tawkScript.onload = () => {
                    if (window.Tawk_API.showWidget) {
                        window.Tawk_API.showWidget();
                    }
                };
            } else {
                // If the widget is already loaded, show it
                if (window.Tawk_API.showWidget) {
                    window.Tawk_API.showWidget();
                }
            }
        },
        hideTawkWidget() {
            if (window.Tawk_API && window.Tawk_API.hideWidget) {
                window.Tawk_API.hideWidget();
            }
        },
        actionSignup() {
            this.$router.push({ name: 'sign-up' })
        },

        actionLogin() {
            this.$router.push({ name: 'login' })
        },

        fetchSetting() {
            Settings
                .where('key', 'noodzly_fee')
                .first()
                .then(setting => {
                    this.netFee = setting?.value || 0;
                })
                .catch((e) => console.log(e))
        },
    },
    components: {
        FooterLogo,
        FooterContact,
        SocialLinks,
        StaticPageLinks,
        ContactUsDialog,
        QrCode,
        CommonDialog,
        GreenCheckmark
    },
};
</script>

<style lang="scss" scoped>
@import "../../sass/vuetify/variables";

.container {
    max-width: 100%;
    padding: 20px;

    @media only screen and (min-width: 991px) {
        max-width: 1220px;
    }
}

.block { 

    padding: 0px 0 20px;

    @media only screen and (min-width: 767px) {
        padding: 20px 0;
    }

    @media only screen and (min-width: 991px) {
        padding: 80px 0;
    }
    
}

h3 { 
    color: #FFFFFF;
    font-family: 'Nunito Sans';
    font-size: 30px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: -0.6px;

    @media only screen and (min-width: 991px) {
        font-size: 36px;
        line-height: 67px;
        letter-spacing: -1px; 
    }
}

.btn {
    min-width: 130px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: 500;
    line-height: 16.8px; 
    border-radius: 100px;
    padding: 12px 20px;

    @media only screen and (min-width: 991px) {
        height: 60px;
        font-size: 18px;
        padding: 16px 30px;
    }

    &.btn-primary {
        border: 1px solid transparent;
        background: var(--01, linear-gradient(268deg, #FF7E3A -2.74%, #FF4081 99.28%));
        color: #FFFFFF;

        &:hover { 
            background: var(--01, linear-gradient(268deg, #FF4081 -2.74%, #FF7E3A 99.28%));
        }
    }

    &.btn-secondary {
        border: 1px solid rgba(255, 255, 255, 0.40);
        background: transparent;
        color: #FFFFFF;

        &:hover {
            background-color: #FFFFFF;
            color: #000000;
        }
    }
}

.heading-style { 
    h2 {
        font-family: 'Nunito Sans';
        font-size: 40px;
        font-weight: 500;
        line-height: 41px;
        letter-spacing: -1.5px;
        text-transform: capitalize;
        color: #FFFFFF;

        @media only screen and (min-width: 767px) {
            font-size: 44px;
            font-weight: 500;
            line-height: 45px;
            letter-spacing: -2.1px;
        }

        @media only screen and (min-width: 991px) {
            font-size: 64px;
            font-weight: 500;
            line-height: 67px;
            letter-spacing: -3px;
        }

        span {
            color: #FF7E3A;
        }
    }

    p {
        color: rgba(255, 255, 255, 0.80);
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: 400;
        line-height: 26px; 
        letter-spacing: -0.3px;

        @media only screen and (min-width: 991px) {
            font-size: 20px;
            font-weight: 400;
            line-height: 32px; 
            letter-spacing: -0.4px;
        }
    }
}

.icon-box-items {
    .icon-box-item {
        position: relative;
        border: 1px solid;
        border-image-slice: 1;
        border-left: 0;
        border-top: 0;
        border-bottom: 0;
        border-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.50) 50%, rgba(255, 255, 255, 0.00) 100%);

        .icon-box-inner {
            margin-bottom: 24px;

            @media only screen and (min-width: 991px) {
                margin-bottom: 0px;
            }

            h4 {
                font-family: 'Nunito Sans';
                font-size: 18px;
                font-weight: 500;
                line-height: 26px; 
                letter-spacing: -0.25px;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 5px;

                @media only screen and (min-width: 767px) {
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 32px; 
                    letter-spacing: -0.5px;
                }
            }

            p {
                color: rgba(255, 255, 255, 0.80);
                font-family: 'Nunito Sans';
                font-size: 14px;
                font-weight: 400;
                line-height: 14px;
                letter-spacing: -0.28px;
            }
        }
    }
}

.icon-left-box-items { 
    .icon-left-box-item {
        .icon-left-box-inner {
            border-radius: 100px;
            border: 1px solid rgba(255, 255, 255, 0.06);
            background: linear-gradient(180deg, rgba(254, 227, 213, 0.07) 0%, rgba(255, 165, 193, 0.07) 100%), linear-gradient(205deg, rgba(4, 5, 9, 0.10) -72.87%, rgba(255, 255, 255, 0.00) 109.39%);
            box-shadow: 0px -1px 1px 0px rgba(255, 255, 255, 0.03) inset;
            backdrop-filter: blur(12px);
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 20px;
            .icon-box {
                width: 56px;
                height: 56px;
                background: var(--01, linear-gradient(268deg, #FF7E3A -2.74%, #FF4081 99.28%));
                box-shadow: 0px 4px 40px 0px rgba(3, 3, 13, 0.56), 0px -28px 84px -23px rgba(255, 255, 255, 0.02) inset;
                backdrop-filter: blur(12px);
                border-radius: 100%;
                border-radius: 48px;
                padding: 12px;
            }

            .icon-box-content {
                width: calc(100% - 56px);
                padding-left: 16px;
                h4 {
                    font-family: 'Nunito Sans';
                    font-size: 18px;
                    font-weight: 500;
                    line-height: 20px; 
                    letter-spacing: -0.25px;
                    color: rgba(255, 255, 255, 1);
                    margin-bottom: 0px;

                    @media only screen and (min-width: 991px) {
                        font-size: 20px;
                        line-height: 20px; 
                        letter-spacing: -0.5px;
                    }

                    
                }
                p {
                    color: rgba(255, 255, 255, 0.80);
                    font-family: 'Nunito Sans';
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 14px;
                    letter-spacing: -0.28px;
                }
            }
        }
    }
}

.icon-top-box-items { 
    .icon-top-box-item {
        .icon-top-box-inner {
            border-radius: 40px;
            border: 1px solid rgba(255, 255, 255, 0.06);
            background: linear-gradient(180deg, rgba(254, 227, 213, 0.07) 0%, rgba(255, 165, 193, 0.07) 100%), linear-gradient(205deg, rgba(4, 5, 9, 0.10) -72.87%, rgba(255, 255, 255, 0.00) 109.39%);
            box-shadow: 0px -1px 1px 0px rgba(255, 255, 255, 0.03) inset;
            backdrop-filter: blur(12px);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            padding: 40px;
            height: 100%;

            .icon-box {
                width: 56px;
                height: 56px;
                background: var(--01, linear-gradient(268deg, #FF7E3A -2.74%, #FF4081 99.28%));
                box-shadow: 0px 4px 40px 0px rgba(3, 3, 13, 0.56), 0px -28px 84px -23px rgba(255, 255, 255, 0.02) inset;
                backdrop-filter: blur(12px);
                border-radius: 100%;
                border-radius: 48px;
                padding: 12px;
                margin-bottom: 16px;
            }

            h4 {
                font-family: 'Nunito Sans';
                font-size: 20px;
                font-weight: 500;
                line-height: 28px; 
                letter-spacing: -0.5px;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 0px;
                text-align: center;
            }   
        }
    }
}

.bg-vector-img {
    background-image: url('../../assets/images/splash/bg-clr-vector.png');
    background-position: left top;
    background-size: auto;
    background-repeat: no-repeat;
}

.hero-block {

    h1 {
        font-family: 'Nunito Sans';
        font-size: 40px;
        font-weight: 500;
        line-height: 36px; 
        letter-spacing: -1.6px;
        color: #FFFFFF;

        @media only screen and (min-width: 767px) {
            font-size: 54px;
            font-weight: 500;
            line-height: 50px; 
            letter-spacing: -2.25px;
        }

        @media only screen and (min-width: 991px) {
            font-size: 72px;
            font-weight: 500;
            line-height: 67px; 
            letter-spacing: -3px;
        }
    }

    p {
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: -0.4px;

        @media only screen and (min-width: 991px) {
            font-size: 20px;
            line-height: 32px;
        }
    }

    .hero-content {
        .button-wrapper {
            justify-content: center;
            @media only screen and (min-width: 991px) { 
                justify-content: flex-start;

            }
        }

        .counter-items { 
            justify-content: center;

            @media only screen and (min-width: 991px) {
                justify-content: start;
            }

            .counter-item {
                .counter-item-inner {
                    span {
                        display: block;
                        text-transform: capitalize;
                        color: #FF7E3A;
                        font-family: 'Nunito Sans';
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 22px;
                        letter-spacing: -0.5px;
                        margin-bottom: 6px;

                        @media only screen and (min-width: 991px) {
                            font-size: 36px;
                            line-height: 32px;
                            letter-spacing: -1px;
                        }
                        
                    }

                    p {
                        color: rgba(255, 255, 255, 0.80);
                        font-family: 'Nunito Sans';
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 14px;
                        letter-spacing: -0.28px;
                    }
                }
            }
        }
    }

    .hero-block-img {
        position: relative;

        &:before {
            height: 157.08px;
            width: 167.74px;
            content:"";
            position: absolute;
            top: 50%;
            left: -210px;
            background-image: url('../../assets/images/splash/arrow-vector-img.png');
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
        }

        h6 {
            font-family: 'Nunito Sans';
            font-size: 24px;
            font-weight: 500;
            line-height: 28px; 
            color: #FFFFFF;
        }

        .img-wrapper {
            display: inline-block;
            border-radius: 35px;
            border: 3px solid var(--01, #FF7E3A);
            background: linear-gradient(180deg, rgba(254, 227, 213, 0.02) 0%, rgba(255, 165, 193, 0.02) 100%), linear-gradient(205deg, rgba(4, 5, 9, 0.10) -72.87%, rgba(255, 255, 255, 0.00) 109.39%);
            box-shadow: 0px 0px 85.5px 0px rgba(255, 108, 78, 0.40), 0px -1px 1px 0px rgba(255, 255, 255, 0.03) inset;
            backdrop-filter: blur(12px);

            img {
                max-width: 100%;
            }
        }
    }
}

.safety-first-block {
    h3 {
        color: #FFF;
        font-size: 28px;
        font-weight: 500;
        line-height: 38px;
        letter-spacing: -0.3px;

        @media only screen and (min-width: 767px) {
            font-size: 32px;
            line-height: 42px;
        }

        @media only screen and (min-width: 991px) {
            font-size: 42px;
            font-weight: 500;
            line-height: 52px;
            letter-spacing: -1px;
        }
    }

    ul {
        list-style-type: none;
        padding-left: 30px;
        margin: 0;
        li {
            position: relative;
            color: #FFF;
            font-family: 'Nunito Sans';
            font-size: 14px;
            line-height: 22px;
            letter-spacing: -0.16px;

            @media only screen and (min-width: 991px) {
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                letter-spacing: -0.32px;
            }


            &:before {
                height: 18px;
                width: 18px;
                content:"";
                position: absolute;
                top: 4px;
                left: -30px;
                background-image: url('../../assets/images/splash/listing-checked-icon.png');
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;

                @media only screen and (min-width: 991px) {
                    height: 21px;
                    width: 21px;
                    top: 2px;
                    left: -30px;
                }
            }
            
            & + li {
                margin-top: 8px;
            }
        }
    }

    p {
        color: rgba(255, 255, 255, 0.80);
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;

        @media only screen and (min-width: 991px) {
            font-size: 18px;
            line-height: 28px;
        }
    }
}

.cta-block { 
    .cta-block-inner {
        text-align: center;
        border-radius: 50px;
        background: var(--01, linear-gradient(268deg, #FF7E3A -2.74%, #FF4081 99.28%));
        padding: 30px;

        @media only screen and (min-width: 991px) {
            padding: 70px;
            text-align: left;
        }

        h2 {
            color: #FFF;
            font-family: 'Nunito Sans';
            font-size: 40px;
            font-weight: 500;
            line-height: 44px; 
            letter-spacing: -0.75px;

            @media only screen and (min-width: 767px) {
                font-size: 54px;
                line-height: 57.25px; 
                letter-spacing: -1.1px;
            } 

            @media only screen and (min-width: 991px) {
                font-size: 72px;
                font-weight: 500;
                line-height: 77px; 
                letter-spacing: -2px;
            }
        }

        h6 {
            color: #FFF;
            font-family: 'Nunito Sans';
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            letter-spacing: -0.24px;

            @media only screen and (min-width: 991px) {
                font-size: 24px;
                line-height: 31px;
                letter-spacing: -0.48px;
            }
        }

        p {
            color: #FFF;
            font-family: 'Nunito Sans';
            font-size: 17px;
            font-weight: 400;
            line-height: 26px;
            letter-spacing: -0.17px;
        }
    }
}

.footer-block {
    p {
        color: #FFF;
        font-family: 'Nunito Sans';
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: -1.1px;

        @media only screen and (min-width: 991px) {
            font-size: 32px;
            line-height: 38px;
            letter-spacing: -1.92px;
        }
    }

    h3 {
        color: #FFF;
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: 600;
        line-height: 20.8px;
        letter-spacing: 0;
    }

    a, span {
        display: inline-block;
        font-family:'Nunito Sans';
        font-size: 12px;
        font-weight: 500;
        line-height: 18.3px;
        margin-bottom: 5px;

        @media only screen and (min-width: 991px) {
            font-size: 14px;
            line-height: 20.3px;

        }
    }

    .copyright-footer {
        p {
            color: rgba(255, 255, 255, 0.70);
            text-align: center;
            font-family: 'Nunito Sans';
            font-size: 14px;
            font-weight: 600;
            line-height: 22px;
            letter-spacing: 0;
            position: relative;
        }
    }
}

.simplified-table-container {
    display: flex;
    overflow: hidden;
    @media only screen and (max-width: 991px) {
      overflow-x: auto;
    }
    .feature-items {
        flex-wrap: wrap;
        @media only screen and (max-width: 991px) {
            flex-wrap: nowrap;
        }
        .feature-item {
            padding: 40px 12px 10px;
            &.sticky { 
                position: -webkit-sticky;
                position: sticky;
                left: 0;
                z-index: 1;
                text-align: left;
                border-radius: 0;
                min-width: 175px;
                max-width: 175px;
                background-color: #000000;
                border-radius: 0px 20px 20px 0px;
                box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.8);
                padding: 20px 0px 10px 20px;

                @media only screen and (min-width: 991px) {
                    &.sticky  {
                        border-radius: initial;
                        box-shadow: none;
                        padding: 40px 0px 10px;
                    } 
                }
            }
            @media only screen and (min-width: 991px)  {
                &.sticky  {
                    position: relative;
                    position: relative;
                    min-width: 300px;
                    max-width: 300px;
                }
            }
            @media only screen and (max-width: 991px) {
                padding: 20px 40px 10px;
            }
            &.highlighted {
                background-color: #FFFFFF12;
                border-radius: 32px;
                box-shadow: 0px 4px 27.5px 0px #FF7E3AB2;
                outline:none;
                background: linear-gradient(#222, #222) padding-box, linear-gradient(268.46deg, #FF7E3A -2.74%, #FF4081 99.28%) border-box;
                border-radius: 32px;
                border: 2px solid transparent;
                margin-left: 60px;
                @media only screen and (max-width: 991px) {
                   margin-left: 0px;
                }

            }
            .highlighted-header  {
                max-height: 70px;
                height: 70px;
                padding: 0px 30px;
                margin-bottom: 10px;
                img {
                    max-width: 180px !important;
                }
            }
            .feature-inner {
                min-height: 70px;
                padding: 0px 30px;
                @media only screen and (max-width: 991px) {
                    padding: 0px;
                    min-height: 55px;
                }
                span {
                    font-weight: 400;
                    font-size: 16px;
                    @media only screen and (max-width: 991px)  {
                        font-size: 14px;
                    }
                }
                p {
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 24px;
                    letter-spacing: -1px;
                    margin-bottom: 0;
                    @media only screen and (max-width: 991px) {
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 20px;
                    }
                    & > span {
                        svg {
                            height: 16px;
                            width: 16px;
                        }
                    }
                }  
            }
        }
    }
}
</style>
